import DetailOverview from 'components/DetailOverview';
import useSetFromOptions from 'hooks/useSetFromOptions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        article: state.CsArticles.selectedArticle,
        brandsOptions: state.vhsBrands.brandsOptions,
    };
}

const ArticleOverview = connect(mapStateToProps)(function ({
    article,
    brandsOptions,
}) {
    const [brandsSet, setBrandsSet] = useSetFromOptions();

    useEffect(() => {
        setBrandsSet(brandsOptions);
        // eslint-disable-next-line
    }, [brandsOptions]);

    return (
        <section>
        {article.poster_url && (
                <img
                    alt={article.title}
                    src={article.poster_url}
                    style={{ maxWidth: '25rem' }}
                    className="mb-4 mt-4"
                />
            )}
        <DetailOverview
            fields={[
                { name: 'Title', value: article.title },
                { name: 'Body', value: article.body, type: 'markdown' },
                { name: 'Posted By', value: article.member.name },
                { name: 'Posted At', value: article.posted_int, type: 'date' },
                { name: 'Featured', value: article.is_featured ? 'Featured' : 'Not Featured' },
                { name: 'Trending', value: article.is_trending ? 'Trending' : 'Not Trending' },
                { name: 'Visibility', value: article.visibility },
                {
                    name: 'Brand',
                    value: brandsSet[article.brand_ident],
                },
                { name: 'Region', value: article.region_ident },
                { name: 'Comments', value: article.responses_count },
                { name: 'Likes', value: article.liked_count },
                { name: 'Flags', value: article.flag_ids.length },
            ]}
        />
        </section>
    );
});

export default ArticleOverview;
